import React from "react"

export default function GeneralLayout({ children }) {

    return (
        <div className="page-container">
            <div className="page-wrapper">
                <div className="page-statistic-wrapper">
                    {children}
                </div>
            </div>
            <div className='page-footer'>
                <span className=''>
                    Copyright © 2020 - {new Date().getFullYear().toString()}. The Next Six Sdn. Bhd. All rights reserved.
                </span>
            </div>
        </div>
    )
}